import React, {useState} from 'react';
import { Switch, Route } from 'react-router-dom';





export default ({Dados, setDados, Loading,  setLoading,  Alert, setAlert, AlertTipo, setAlertTipo, Avisando, setAvisando }) => {

   
    return (
        <Switch> 
             
          
            
            
        </Switch>
    )
}